import React from 'react'

const SectionHeading = ({ headingText, subheaderText, icon }) => {
    return (
        <div className="trip-reservation__section-headings">
            {icon ? <img src={icon} alt="" className="trip-reservation__section-icon" /> : null}
            <div className="trip-reservation__section-heading">{headingText}</div>
            <div className="trip-reservation__section-subheader">{subheaderText}</div>
        </div>
    )
}

export default SectionHeading
